import React, { useState, useContext, useEffect, useRef } from "react"
import { useFormContext } from "react-hook-form"
import intl from "react-intl-universal"
import { NumericFormat } from "react-number-format"
import moment from "moment"

import { cDeadLineSlug, cDescritionSlug, cStatusFieldName, cStatusSlug, dConclusionDateSlug, dCreationDateSlug } from "../../../constans/activity-slugs"
import AuthContext from "../../../contexts/Auth"
import BoardContext from "../../../contexts/Board"
import PaineisContext from "../../../contexts/Paineis"
import { fnFormatDate, fnFormatDateFromUTC, fnFormatDateToUTC } from "../../../utils/date"
import RcmpDatePicker from "../../atoms/DatePicker"
import RcmpFormErrorMessage from "../../atoms/FormErrorMessage"
import Input from "../../atoms/Input"
import Label from "../../atoms/Label"
import Select from "../../atoms/Select"
import SwitchComponent from "../../atoms/Switch"
import RcmpTextArea from "../../atoms/TextArea"
import RcmpSelectUsers from "../../molecules/SelectUsers"
import styles from "./index.module.scss"
import MoveEllipsisIcon from "../../../assets/icons/MoveEllipsisIcon"
import { isEqual } from "../../../utils/compare"

const RcmpTextField = React.forwardRef((props, ref) => {
  const { cFieldName, setValue, bIsDisabled, required, ...oRest } = props
  return (
    <Input
      disabled={bIsDisabled}
      ref={ref}
      isFullWidth
      onChange={(e) => setValue(cFieldName, e.target.value)}
      {...oRest}
    />
  )
})
const RcmpMemoTextField = React.memo(RcmpTextField)


const RcmpDateField = React.forwardRef((props, ref) => {
  const { required, setValue, watch, cFieldName, register, disabled, oFieldValue, bIsEditModel, ...oRest } = props

  const cUserTimeZone = "UTC"


  return (
    <RcmpDatePicker
      ref={ref}
      defaultValue={oFieldValue?.value}
      {...register(cFieldName)}
      {...oRest}
      bTime={true}
      disabled={disabled}
      onChange={(e) => {
        const bIsSameDate = fnFormatDate(oFieldValue?.value, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]", false, cUserTimeZone, "YYYY-MM-DD HH:mm") === fnFormatDate(e, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]", false, cUserTimeZone, "YYYY-MM-DD HH:mm")
        setValue(cFieldName, fnFormatDate(e, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]", false, cUserTimeZone, "YYYY-MM-DD HH:mm"), { shouldDirty: !bIsSameDate })
      }}
    />
  )
})

const RcmpSelectionField = React.forwardRef((props, ref) => {
  const { setValue, cFieldName, register, watch, options, id, oFieldValue, bIsDisabled, required, ...oRest } = props

  const aFormatedOptions = options?.map((oOption) => ({
    ...oOption,
    label: oOption?.optionName,
    value: oOption?.id,
  }))

  const oOption = oFieldValue?.selected_option
  const oDefaultValue = oOption
    ? { label: oOption?.optionName, value: oOption?.id }
    : null

  return (
    <Select
      ref={ref}
      options={aFormatedOptions}
      defaultValue={oDefaultValue}
      disabled={bIsDisabled}
      {...register(cFieldName)}
      onSelect={(cSelectedValue) => {
        const bIsDirty = isEqual(cSelectedValue, oDefaultValue)
        setValue(cFieldName, cSelectedValue?.value, { shouldDirty: !bIsDirty })
      }
      }
      {...oRest}
    />
  )
})

// const RcmpPeoplesField = React.forwardRef((props, ref) => {
//   const { setValue, cFieldName, register, watch, id, options, oFieldValue, bIsDisabled, ...oRest } = props
//   const aDefaultValue = oFieldValue?.value?.length

//     ? oFieldValue?.value?.map((oUser) => ({
//       value: oUser?.id,
//       label: oUser?.name,
//     }))
//     : []

//   function fnHandleSetValues(aUsers) {
//     if (!aUsers?.length) {
//       setValue(cFieldName, [])
//       return
//     }
//     const bIsDirty = isEqual(aUsers, aDefaultValue)
//     setValue(
//       cFieldName,
//       aUsers?.map((oUser) => oUser?.value),
//       { shouldDirty: !bIsDirty }
//     )
//   }

//   return (
//     <RcmpSelectUsers
//       disabled={bIsDisabled}
//       ref={ref}
//       multiSelect
//       isFullWidth
//       searchable
//       defaultValue={aDefaultValue}
//       onSelect={(fnHandleSetValues)}
//       {...oRest}
//     />
//   )
// })

const RcmpNumberField = React.forwardRef((props, ref) => {
  const { cFieldName, setValue, getValues, register, prefix, suffix, precision, bIsDisabled, required, label } = props
  function ElInputNumber(customProps) {
    const elPrefix = prefix ? <span>{prefix}</span> : null
    const elSufix = suffix ? <span>{suffix}</span> : null

    return (

      <Input
        isFullWidth
        disabled={bIsDisabled}
        iconLeft={elPrefix}
        iconRight={elSufix}
        label={label}
        {...register(cFieldName)}
        {...customProps}
      />
    )
  }

  function fnHandleOnChange(e) {
    const value = e?.target?.value
    const bIsDirty = getValues(cFieldName) === value
    setValue(cFieldName, value, { shouldDirty: !bIsDirty })
  }

  return (
    <>

      <NumericFormat
        ref={ref}
        className={styles.numberField}
        defaultValue={getValues(cFieldName)}
        decimalScale={precision || 0}
        allowLeadingZeros
        fixedDecimalScale
        decimalSeparator=","
        customInput={ElInputNumber}
        onChange={fnHandleOnChange}
      />
    </>

  )
})
const RcmpMemoNumberField = React.memo(RcmpNumberField)

const RcmpRangeField = React.forwardRef((props, ref) => {
  const { cFieldName, setValue, getValues, register, prefix, suffix, precision, bIsDisabled, required, label, oFieldValue, ...oRest } = props
  const [cRangeMessage, fnSetCRangeMessage] = useState("")
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  });
  //range functions
  function handleCheckRange(value, e) {
    // inputRef.current.onFocus
    if (prefix && value.startsWith(prefix)) {
      value = value.slice(prefix.length);
    }
    if (suffix && value.endsWith(suffix)) {
      value = value.slice(0, -suffix.length);
    }
    if (!props.max_ideal || !props.min_ideal || !props.max_limit || !props.min_limit) return

    //verifica se value é maior que o props.min_limit
    let minLimit = Number(props.min_limit.replace(',', '.'))
    let minIdeal = Number(props.min_ideal.replace(',', '.'))
    let maxIdeal = Number(props.max_ideal.replace(',', '.'))
    let maxLimit = Number(props.max_limit.replace(',', '.'))
    if (props.required === false && value === "") {
      fnSetCRangeMessage("")
      return
    }


    if (minLimit && Number(value.replace(',', '.')) < minLimit) {
      fnSetCRangeMessage("Insira um valor entre o Limite Mínimo e o Limite Máximo")

      return
    }
    if (
      minLimit &&
      minIdeal &&
      Number(value.replace(',', '.')) >= minLimit &&
      Number(value.replace(',', '.')) <= minIdeal
    ) {
      fnSetCRangeMessage(
        "Atenção: O número digitado está entre o Limite Mínimo e o Mínimo Ideal",
      )
      return
    }
    if (
      minIdeal &&
      maxIdeal &&
      Number(value.replace(',', '.')) > minIdeal &&
      Number(value.replace(',', '.')) < maxIdeal
    ) {
      fnSetCRangeMessage("")
      return
    }
    if (maxIdeal && Number(value.replace(',', '.')) >= maxIdeal && Number(value.replace(',', '.')) <= maxLimit) {
      fnSetCRangeMessage(
        "Atenção: O número digitado está entre o Máximo Ideal  e o Limite Máximo",
      )
      return

    }
    if (maxLimit && Number(value.replace(',', '.')) > maxLimit) {
      fnSetCRangeMessage("Insira um valor entre o Limite Mínimo e o Limite Máximo")
      return

    }
  }

  const handleRangeColorCheck = () => {
    const type = props.typetype
    if (!getValues(cFieldName)) return ""
    if (type !== "RANGE") return ""
    if (!props.max_ideal || !props.min_ideal || !props.max_limit || !props.min_limit) return ""
    const value = Number(getValues(cFieldName).replace(',', '.'))
    const minIdeal = Number(props.min_ideal.replace(',', '.'))
    const maxIdeal = Number(props.max_ideal.replace(',', '.'))
    const minLimit = Number(props.min_limit.replace(',', '.'))
    const maxLimit = Number(props.max_limit.replace(',', '.'))

    if (value < minLimit || value > maxLimit) return styles.rangeError
    if (value >= minLimit && value <= minIdeal || value >= maxIdeal && value <= maxLimit) return styles.rangeError

  }

  function fnHandleOnChange(e) {
    const value = e?.target?.value
    setValue(cFieldName, value)
    handleCheckRange(value, e)
  }
  const cClass = `${styles.numberField} ${handleRangeColorCheck()} ${props.suffix ? styles.numberFieldSuffix : ""
    }`

  function fnHandleOnBlur(e) {
    const value = e?.target?.value

    /* handleCheckRange(value, e) */
  }
  //end range functions

  const ElInputNumber = (props) => {
    const {
      opfd_cprefix,
      prefix,
      opfd_csuffix,
      suffix,
      bIsDraggable = false,
      bIsDisabled,
    } = props

    const elPrefix = props.prefix || prefix ? <span>{props.prefix || prefix}</span> : null
    const elSufix = props.suffix || suffix ? <span>{props.suffix || suffix}</span> : null

    return (
      <Input
        ref={inputRef}
        isFullWidth
        disabled={bIsDisabled}
        iconLeft={elPrefix}
        iconRight={elSufix}
        bIsDraggable={bIsDraggable}
        {...props}
      />
    )
  }
  return (
    <>
      <NumericFormat

        className={cClass}
        defaultValue={getValues(cFieldName)}
        decimalScale={props.precision || 0}
        allowLeadingZeros
        fixedDecimalScale
        decimalSeparator=","
        customInput={ElInputNumber}
        onChange={fnHandleOnChange}
        opfd_cprefix={props.prefix !== null ? `${props.prefix} ` : ''}
        prefix={props.prefix !== null ? `${props.prefix} ` : ''}
        opfd_csuffix={props.suffix !== null ? ` ${props.suffix}` : ''}
        suffix={props.suffix !== null ? ` ${props.suffix}` : ''}
        onBlur={fnHandleOnBlur}
        label={props.label}
      // {...props}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          marginTop: "8px",
        }}
      >
        {cRangeMessage && (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "8px 16px",
              border: "1px solid #FF7835",
              backgroundColor: "#FF783514",
              borderRadius: "500px",
              color: "#FF7835",
            }}
          >
            {cRangeMessage}
          </span>
        )}
        <div style={{ display: "flex", gap: "8px" }}>
          <span
            style={{
              border: "1px solid #CCD1D6",
              backgroundColor: "#FFF",
              padding: "8px 12px",
              borderRadius: "4px",
              fontWeight: "600",
              color: "#415364",
              fontSize: "14px",
            }}
          >
            Limite Mín.: {props.min_limit}
          </span>
          <span
            style={{
              border: "1px solid #CCD1D6",
              backgroundColor: "#FFF",
              padding: "8px 12px",
              borderRadius: "4px",
              fontWeight: "600",
              color: "#415364",
              fontSize: "14px",
            }}
          >
            Mín. Ideal: {props.min_ideal}
          </span>
          <span
            style={{
              border: "1px solid #CCD1D6",
              backgroundColor: "#FFF",
              padding: "8px 12px",
              borderRadius: "4px",
              fontWeight: "600",
              color: "#415364",
              fontSize: "14px",
            }}
          >
            Máx. Ideal: {props.max_ideal}
          </span>
          <span
            style={{
              border: "1px solid #CCD1D6",
              backgroundColor: "#FFF",
              padding: "8px 12px",
              borderRadius: "4px",
              fontWeight: "600",
              color: "#415364",
              fontSize: "14px",
            }}
          >
            Limite Máx.: {props.max_limit}
          </span>
        </div>
      </div>
    </>
  )
})
const RcmpMemoRangeField = React.memo(RcmpRangeField)
const RcmpFormField = React.forwardRef((props, ref) => {
  const { id, type, slug, required, name, values, bIsDisabled = false, bIsEditModel = false, bIsEdit, } = props

  const useFormMethods = useFormContext()




  const {
    getValues,
    setValue,
    register,
    unregister,
    watch,
    formState: { errors },
  } = useFormMethods
  const cUserTimeZone = "utc"
  const cFieldName = `activity-field-${id}`

  useEffect(() => {
    return () => {
      unregister(cFieldName)
    }
  }, [])



  if (!id) return null

  const oFieldValue = values?.find((v) => v?.id === id)

  let cLabel = ""

  if (required) {
    cLabel = (
      <div className={styles.requiredTextContainer}>
        <p className={styles.fieldName}>{`${name}*`} </p>

      </div>
    )

  } else {
    cLabel = (
      <div className={styles.requiredTextContainer}>
        <p className={styles.fieldName}>{`${name}`} </p>
      </div>
    )
  }

  // if (getValues(cFieldName) === undefined && oFieldValue?.value) {

  //   if (type === "SELECTION" && slug !== cStatusSlug) {
  //     setValue(cFieldName, oFieldValue?.selected_option?.id)
  //     return
  //   }

  // if (type === "DATE") {
  //  const dFormatedDate = fnFormatDateFromUTC(oFieldValue.value, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]", cUserTimeZone)
  //  oFieldValue.value = dFormatedDate
  //  setValue(cFieldName, dFormatedDate)
  //  return
  //}

  //   setValue(cFieldName, oFieldValue.value)

  // } else {

  //   if (type === "SELECTION" && slug !== cStatusSlug && !bIsEdit && !getValues(cFieldName)) {
  //     setValue(cFieldName, null)

  //   }
  //   if (type === "SELECTION" && slug !== cStatusSlug && bIsEdit && oFieldValue?.selected_option === null && !getValues(cFieldName)) {
  //     setValue(cFieldName, null)

  //   }

  //   if (type === "DATE" && !bIsEdit && !getValues(cFieldName)?.length) {
  //     setValue(cFieldName, "")

  //   }
  // }


  function fnRenderField() {
    if (slug === cDescritionSlug) {
      return (
        <div className={styles.description}>
          <RcmpTextArea
            disabled={bIsDisabled}
            label={cLabel}
            {...register(cFieldName)}
          />
        </div>
      )
    }

    if (type === "TEXT") {
      return (
        <RcmpMemoTextField
          ref={ref}
          label={cLabel}
          required={false}
          cFieldName={cFieldName}
          setValue={setValue}
          {...useFormMethods}
          {...props}
        />
      )
    }

    if (type === "DATE") {
      return (
        <RcmpDateField
          className={styles.datePickerStyle}
          ref={ref}
          label={cLabel}
          disabled={bIsDisabled}
          required={false}
          cFieldName={cFieldName}
          bIsEditModel={bIsEditModel}
          oFieldValue={oFieldValue}
          {...useFormMethods}
          {...props}
        />
      )
    }

    if (type === "SELECTION") {

      return (
        <RcmpSelectionField
          ref={ref}
          label={cLabel}
          required={false}
          cFieldName={cFieldName}
          oFieldValue={oFieldValue}
          {...useFormMethods}
          {...props}
        />
      )
    }

    if (type === "NUMBER") {
      return (
        <RcmpMemoNumberField
          ref={ref}
          label={cLabel}
          required={false}
          cFieldName={cFieldName}
          oFieldValue={oFieldValue}
          {...useFormMethods}
          {...props}
        />
      )
    }

    if (type === "RANGE") {
      return (
        <RcmpMemoRangeField
          ref={ref}
          label={cLabel}
          required={false}
          cFieldName={cFieldName}
          oFieldValue={oFieldValue}
          getrValues={getValues}
          {...useFormMethods}
          {...props}
        />
      )
    }

    return null
  }

  return (
    <div className={styles.fieldContainer}>
      {fnRenderField()}
      <RcmpFormErrorMessage>{errors[cFieldName]?.message}</RcmpFormErrorMessage>
    </div>
  )
})

export default RcmpFormField
